import "./Project.css"

import { Link } from "react-router-dom"

function Project(prop) {
    return (
        <div className="Project">
            <Link to={"/" + prop.project.link}>
            {/*get thumbnail*/}
            <div className="flex-container">
            <img src={require("./Resources/" + prop.project.thumbnail)} alt={prop.project.thumbnail}/>
            <div className="projectInfo">
                {/*Get Title*/}
                <h2>{prop.project.name}</h2>
                {/*description cut off- text-overflow: ellipsis and white-space: nowrap and overflow: hidden*/}
                <div className="projectDesc">
                    <p>{prop.project.desc}</p>
                </div>
            </div>
            </div>
            </Link>
        </div>
    );
}

export default Project